import { ServiceException } from '@uzurv/rideWss/app/exceptions';
import { isNullOrUndefined } from '@uzurv/rideWss/app/util';

export interface AuthenticatedUserData {
  userId: number;
  claraPersonId: number;
  dotsDriverId?: number;
  firstName: string;
  lastName: string;
  username: string;
}

export class AuthenticatedUser {
  private _userId: number;
  private _claraPersonId: number;
  private _dotsDriverId: number;
  private _firstName: string;
  private _lastName: string;
  private _username: string;

  constructor(userData: AuthenticatedUserData) {
    if (isNullOrUndefined(userData)) {
      throw new ServiceException('AuthenticatedUser userData cannot be null');
    }
    this._userId = userData.userId;
    this._claraPersonId = userData.claraPersonId;
    this._dotsDriverId = userData.dotsDriverId;
    this._firstName = userData.firstName;
    this._lastName = userData.lastName;
    this._username = userData.username;
  }

  get userId(): number {
    return this._userId;
  }

  get claraPersonId(): number {
    return this._claraPersonId;
  }

  get dotsDriverId(): number {
    return this._dotsDriverId;
  }

  get firstName(): string {
    return this._firstName;
  }

  get lastName(): string {
    return this._lastName;
  }

  get username(): string {
    return this._username;
  }

  // TODO: (Brandon) Remove this in favor of serialization methods? Explicitly build instance and json in those.

  toJSON(): AuthenticatedUserData {
    return {
      userId: this.userId,
      claraPersonId: this.claraPersonId,
      dotsDriverId: this.dotsDriverId,
      firstName: this.firstName,
      lastName: this.lastName,
      username: this.username
    };
  }
}
